module.exports = {"441881001":"英城街道","441881101":"沙口镇","441881102":"望埠镇","441881103":"横石水镇","441881105":"桥头镇","441881106":"青塘镇","441881108":"白沙镇","441881109":"大站镇","441881110":"西牛镇","441881111":"九龙镇","441881112":"含光镇","441881114":"大湾镇","441881115":"石灰铺镇","441881116":"石牯塘镇","441881120":"下太镇","441881124":"波罗镇","441881125":"横石塘镇","441881126":"大洞镇","441881129":"连江口镇","441881130":"黎溪镇","441881131":"水边镇","441881136":"英红镇","441881137":"东华镇","441881138":"黄花镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441881.json
// module id = 1878
// module chunks = 0